import _Abstract from "system/abstract"

export default class Module_Tabs extends _Abstract {

    constructor(el, options) {
        super(el, $.extend(true, {}, options), 'module')

        this.initModule();


    }

    /********* Initialising ***************/

    initModule() {
        // this.$mList = this.$el.closest(".m-list");
        // this.$mListColumns = this.$el.closest(".m-list").find(".m-columns__columns");
        // this.$mContainerList = this.$mList.find(".m-list__list");
        // this.$elItemBtn = this.$el.find("a");
        // this.$elItemSelect = this.$el.find("select")
        this.initListener();
    }

    initListener() {
        // this.$el.on("click", "a", (e) => this.onItemClicked(e));
        // this.$el.on("change", "select", (e) => this.onSelectBoxChanged(e));

        this.onTabsItemClicked();
    }

    onTabsItemClicked() {
        $(".c-tabs > li > a").on("click", function (e) {
            e.preventDefault();
            var hash = $(this).attr('href');
            //window.location.hash = 'tab-' + hash.replace('#', '');

            if ($(this).hasClass("-active")) { //detection for current tab
                return;
            } else {
                $(".c-tabs__content > .c-tabs__content-item").hide();
                $(".c-tabs > li > a").removeClass("-active");
                $(this).addClass("-active"); // Activate this
                $(hash).fadeIn(); // Show content for current tab
            }
        });

        $(".c-tabs > li:first > a").trigger('click');

        if (window.location.hash != '') {
            $('.c-tabs > li > a[href="' + window.location.hash.replace('tab-', '') + '"]').trigger('click');
            var $tabElements = $('.c-tabs');
            $('html, body').animate({
                scrollTop: $tabElements.offset().top - 30
            }, 1000);
        }
    }

    

}


/** WEBPACK FOOTER **
 ** ./modules/tabs.js
 **/